export const BI_LOADING_TEXT = "Loading the Benefit Illustration";
export const BI_ACTION_SHEET_HEADING = "Error fetching your document";
export const BI_ACTION_SHEET_DESCRIPTION_1 = "Not to worry! We have also sent this document to your registered email ID & mobile number";
export const BI_ACTION_SHEET_DESCRIPTION_2 = " Please connect with your seller for further details.";